import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import { toast } from "react-toastify";
import {
  new_checklist,
} from "../api/Users";
import { useNavigate } from "react-router-dom";

const LaunchSurvey = ({ userData, role }) => {
  const { t } = useTranslation();

  
  const [isLoading, setIsLoading] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(null);

  const [survey, setSurvey] = useState({
    name: "",
    category: "",
    file: "",
    HM: false,
    WEO: false,
    DWO: false,
    DS: false,
    DD: false,
    // questions: [{ question: "", type: "", custom: "", options: [] }],
  });

  const handleChangeInput = (e, index) => {
    const { name, value, type, files, checked } = e.target;
    if (type !== "file") {
      if (type === "checkbox") {
        if (name === "all") {
          setSurvey((prevData) => ({
            ...prevData,
            HM: checked,
            WEO: checked,
            DWO: role === 5 ? prevData.DWO : checked,
            DS: role === 5 || role === 6 ? prevData.DS : checked,
            DD: role === 5 || role === 6 || role === 8 ? prevData.DD : checked,
            [name]: checked,
          }));
        } else {
          setSurvey((prevData) => ({ ...prevData, [name]: checked }));
        }
      } else {
        // if (name === "question" || name === "type" || name === "custom") {
        //   const newQuestions = [...survey.questions];
        //   newQuestions[index][name] = value;
        //   setSurvey((prevData) => ({
        //     ...prevData,
        //     questions: newQuestions,
        //   }));
        // } else {
          setSurvey((prevData) => ({ ...prevData, [name]: value }));
        // }
      }
    } else {
      const file = files[0];
      setSurvey((prevData) => ({ ...prevData, [name]: file }));
      setPhotoUrl(URL.createObjectURL(file));
    }
  };  

  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();

    formData.append("name", survey.name);
    formData.append("file", survey.file);
    formData.append("gm_id", userData.data.gm_id);
    formData.append("category", survey.category);

    const selectedRoles = [];
    if (survey.HM) selectedRoles.push("4");
    if (survey.WEO) selectedRoles.push("5");
    if (survey.DWO) selectedRoles.push("6");
    if (survey.DS) selectedRoles.push("8");
    if (survey.DD) selectedRoles.push("11");

    const rolesString = selectedRoles.join(",");
    formData.append("checklist_access_roles", rolesString);

    // survey.questions.forEach((q, qIndex) => {
    //   formData.append(`question_${qIndex}`, q.question);
    //   formData.append(`type_${qIndex}`, q.type);
    //   formData.append(`custom_${qIndex}`, q.custom);
    //   q.options.forEach((option, oIndex) => {
    //     formData.append(`option_${qIndex}_${oIndex}`, option);
    //   });
    // });

    new_checklist(formData)
      .then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          toast.success(t(res.message));
          navigate(`/all-checklist`);
          setSurvey({
            name: "",
            file: "",
            HM: false,
            WEO: false,
            DWO: false,
            DS: false,
            DD: false,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        } else {
          toast.error(t(res.message));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddOption = (index) => {
    const newQuestions = [...survey.questions];
    newQuestions[index].options.push("");
    setSurvey((prevNotice) => ({ ...prevNotice, questions: newQuestions }));
  };

  const handleRemoveOption = (qIndex, oIndex) => {
    const newQuestions = [...survey.questions];
    newQuestions[qIndex].options.splice(oIndex, 1); // Remove the option at the specified index
    setSurvey((prevNotice) => ({ ...prevNotice, questions: newQuestions }));
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Add New Checklist Details")}</h5>
        </div>

        <form
          onSubmit={(e) => onSubmit(e)}
          id="myform"
          style={{ marginTop: "12px" }}
        >
          <div className="row col-12">
            <div
              className="row col-8 p-3 d-flex justify-content-center"
              style={{ borderRight: "1px solid gray" }}
            >
              {/* <div className="col-md-8">
                <label className="form-label">
                  {t("Checklist Name")}{" "}
                  {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="text"
                  name="heading"
                  value={survey.heading}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Select Answer Type")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="answer"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Select answer type")}</option>
                    <option value="checkbox">{t("Checkbox")}</option>
                    <option value="slider">{t("Slider")}</option>
                    <option value="radio">{t("Radio")}</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Custom Input")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="custom"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Custom Input")}</option>
                    <option value="checkbox">{t("Yes")}</option>
                    <option value="checkbox">{t("No")}</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <label className="form-label">
                  {t("Question")} {<span style={{ color: "red" }}>*</span>}
                </label>
                <input
                  type="textarea"
                  name="question"
                  value={survey.question}
                  className="form-control"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              {survey.questions.map((question, qIndex) => (
                <div key={qIndex} className="col-md-12">
                  <div className="row mt-3">
                    <div
                      className="col-md-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <label className="form-label">
                          {t("Options")}{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        {question.options.map((option, oIndex) => (
                          <div key={oIndex} className="input-group mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Option"
                              value={option}
                              onChange={(e) => handleChangeInput(e, qIndex)}
                            />
                            <button
                              className="btn btn-outline-danger"
                              type="button"
                              onClick={() => handleRemoveOption(qIndex, oIndex)}
                            >
                              
                            </button>
                          </div>
                        ))}
                        <br />
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => handleAddOption(qIndex)}
                        >
                          {t("Add Option")}
                        </button>
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">
                          {t("Upload Photo")}{" "}
                          {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input
                          type="file"
                          name="photo_file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control"
                          onChange={handlePhotoChange}
                        />
                        {error.photo_file && (
                          <div className="text-danger">{error.photo_file}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))} */}

              <div className="col-md-6 d-flex justify-content-center align-items-center row">
                {photoUrl === null ? (
                  <div
                    className="border border-4 bg-light d-flex align-items-center justify-content-center rounded text-dark "
                    style={{
                      height: "40vh",
                      width: "40vh",
                    }}
                  >
                    <p style={{ zIndex: "100" }}>{t("Checklist Image")}</p>
                  </div>
                ) : (
                  <div
                    className="uploadedPhotoDisplay"
                    style={{
                      height: "40vh",
                      width: "40vh",
                      backgroundImage: `url(${photoUrl})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                  ></div>
                )}
              </div>
              <div className="col-md-6 d-flex justify-content-center row">
                <div className="col-md-12">
                  <label className="form-label">
                    {t("Select Category")}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="category"
                    className="common-input form-select"
                    onChange={handleChangeInput}
                    required
                  >
                    <option value="">{t("Select Category")}</option>
                    <option value="inspection">{t("Inspection")}</option>
                  </select>
                </div>
                <div className="col-md-12">
                  <label className="form-label">
                    {t("Checklist Name")}{" "}
                    {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={survey.heading}
                    className="form-control"
                    onChange={handleChangeInput}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label text-center">
                    {t("Upload Photo")}{" "}
                    {<span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                    type="file"
                    name="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control"
                    onChange={handleChangeInput}
                  />
                </div>
              </div>
            </div>
            <div className="col-4 p-5 pt-3 row">
              <h5 className="col-md-12 d-flex justify-content-between">
                {t("Select For Roles")}:
              </h5>
              <div className="mt-2">
                <div className="row">
                  <div className="col-md-12 d-flex">
                    <label className="form-label m-2 fw-bold">
                      {t("Select All")}:
                    </label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="all"
                      checked={survey.all}
                      onChange={handleChangeInput}
                    />
                  </div>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("HM")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="HM"
                      checked={survey.HM}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("WEO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="WEO"
                      checked={survey.WEO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row" style={{display: role == 5 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DWO")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DWO"
                      checked={survey.DWO}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row"style={{display: role == 5 || role == 6 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DS")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DS"
                      checked={survey.DS}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
                <div className="row"style={{display: role == 5 || role == 6 || role == 8 ? "none" : "block"}}>
                  <div className="col-md-12 d-flex justify-content-between">
                    <label className="form-label m-2">{t("DD")}:</label>
                    <input
                      className="m-2 largerCheckbox form-check-input"
                      type="checkbox"
                      name="DD"
                      checked={survey.DD}
                      onChange={handleChangeInput}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row col-12 mt-5 d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary me-2 col-md-2"
            >
              {t("Add")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default LaunchSurvey;
